module.exports = "/images/Logo-Text-Below-Mail.png?8dcc806aec340467d2e1c02e02ba39a2";